module.exports = {"version":"master-23","git_hash":"de0533834586d0456ae96981951ce105e3ee71d7"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 1005
// module chunks = 0